module.exports = __webpack_public_path__ + "static/img/verify-bg.343c620.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/verify-bg.jpg
// module id = GiY2
// module chunks = 0